import { IconButton } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import youstad from "../../../assets/youstad.mp4";
import { useRef, useState } from "react";

const Video = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handlePlayPause = () => {
    if (isPlaying) {
      videoRef.current.pause();
      setIsPlaying(false);
    } else {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "2rem",
        position: "relative",
      }}
    >
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
      <video
        ref={videoRef}
        style={{ height: "36.75rem", borderRadius: "1rem" }}
      >
        <source src={youstad} type="video/mp4" />
      </video>
      <div>
        <IconButton
          onClick={handlePlayPause}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            cursor: "pointer",
            opacity: isHovered ? 1 : 0,
            transition: "opacity 0.3s",
          }}
        >
          {isPlaying ? (
            <PauseIcon
              sx={{
                color: "#006BFF",
                border: "5px solid #006BFF",
                borderRadius: "50%",
                height: "6.645625rem",
                width: "6.645625rem",
              }}
            />
          ) : (
            <PlayArrowIcon
              sx={{
                color: "#006BFF",
                border: "5px solid #006BFF",
                borderRadius: "50%",
                height: "6.645625rem",
                width: "6.645625rem",
              }}
            />
          )}
        </IconButton>
      </div>
      </div>
    </div>
  );
};

export default Video;
